/**
 * Daftar kabupaten/kota per provinsi untuk mendeteksi lokasi dari alamat teks.
 * Disusun dari a.json (daftar kota RajaOngkir), ditambah kabupaten hasil
 * pemekaran 2012-2014, perubahan nama kabupaten, dan pemekaran Papua 2022.
 */
export const WILAYAH: Record<string, { kab: string[]; kota: string[] }> = {
  Aceh: {
    kab: [
      "Aceh Barat",
      "Aceh Barat Daya",
      "Aceh Besar",
      "Aceh Jaya",
      "Aceh Selatan",
      "Aceh Singkil",
      "Aceh Tamiang",
      "Aceh Tengah",
      "Aceh Tenggara",
      "Aceh Timur",
      "Aceh Utara",
      "Bener Meriah",
      "Bireuen",
      "Gayo Lues",
      "Nagan Raya",
      "Pidie",
      "Pidie Jaya",
      "Simeulue",
    ],
    kota: ["Banda Aceh", "Langsa", "Lhokseumawe", "Sabang", "Subulussalam"],
  },
  "Sumatera Utara": {
    kab: [
      "Asahan",
      "Batu Bara",
      "Dairi",
      "Deli Serdang",
      "Humbang Hasundutan",
      "Karo",
      "Labuhan Batu",
      "Labuhan Batu Selatan",
      "Labuhan Batu Utara",
      "Langkat",
      "Mandailing Natal",
      "Nias",
      "Nias Barat",
      "Nias Selatan",
      "Nias Utara",
      "Padang Lawas",
      "Padang Lawas Utara",
      "Pakpak Bharat",
      "Samosir",
      "Serdang Bedagai",
      "Simalungun",
      "Tapanuli Selatan",
      "Tapanuli Tengah",
      "Tapanuli Utara",
      "Toba",
    ],
    kota: [
      "Binjai",
      "Gunungsitoli",
      "Medan",
      "Padang Sidempuan",
      "Pematang Siantar",
      "Sibolga",
      "Tanjung Balai",
      "Tebing Tinggi",
    ],
  },
  "Sumatera Barat": {
    kab: [
      "Agam",
      "Dharmasraya",
      "Kepulauan Mentawai",
      "Lima Puluh Kota",
      "Padang Pariaman",
      "Pasaman",
      "Pasaman Barat",
      "Pesisir Selatan",
      "Sijunjung",
      "Solok",
      "Solok Selatan",
      "Tanah Datar",
    ],
    kota: [
      "Bukittinggi",
      "Padang",
      "Padang Panjang",
      "Pariaman",
      "Payakumbuh",
      "Sawah Lunto",
      "Solok",
    ],
  },
  Riau: {
    kab: [
      "Bengkalis",
      "Indragiri Hilir",
      "Indragiri Hulu",
      "Kampar",
      "Kepulauan Meranti",
      "Kuantan Singingi",
      "Pelalawan",
      "Rokan Hilir",
      "Rokan Hulu",
      "Siak",
    ],
    kota: ["Dumai", "Pekanbaru"],
  },
  "Kepulauan Riau": {
    kab: ["Bintan", "Karimun", "Kepulauan Anambas", "Lingga", "Natuna"],
    kota: ["Batam", "Tanjung Pinang"],
  },
  Jambi: {
    kab: [
      "Batang Hari",
      "Bungo",
      "Kerinci",
      "Merangin",
      "Muaro Jambi",
      "Sarolangun",
      "Tanjung Jabung Barat",
      "Tanjung Jabung Timur",
      "Tebo",
    ],
    kota: ["Jambi", "Sungaipenuh"],
  },
  "Sumatera Selatan": {
    kab: [
      "Banyuasin",
      "Empat Lawang",
      "Lahat",
      "Muara Enim",
      "Musi Banyuasin",
      "Musi Rawas",
      "Musi Rawas Utara",
      "Ogan Ilir",
      "Ogan Komering Ilir",
      "Ogan Komering Ulu",
      "Ogan Komering Ulu Selatan",
      "Ogan Komering Ulu Timur",
      "Penukal Abab Lematang Ilir",
    ],
    kota: ["Lubuk Linggau", "Pagar Alam", "Palembang", "Prabumulih"],
  },
  "Kepulauan Bangka Belitung": {
    kab: [
      "Bangka",
      "Bangka Barat",
      "Bangka Selatan",
      "Bangka Tengah",
      "Belitung",
      "Belitung Timur",
    ],
    kota: ["Pangkal Pinang"],
  },
  Bengkulu: {
    kab: [
      "Bengkulu Selatan",
      "Bengkulu Tengah",
      "Bengkulu Utara",
      "Kaur",
      "Kepahiang",
      "Lebong",
      "Muko Muko",
      "Rejang Lebong",
      "Seluma",
    ],
    kota: ["Bengkulu"],
  },
  Lampung: {
    kab: [
      "Lampung Barat",
      "Lampung Selatan",
      "Lampung Tengah",
      "Lampung Timur",
      "Lampung Utara",
      "Mesuji",
      "Pesawaran",
      "Pesisir Barat",
      "Pringsewu",
      "Tanggamus",
      "Tulang Bawang",
      "Tulang Bawang Barat",
      "Way Kanan",
    ],
    kota: ["Bandar Lampung", "Metro"],
  },
  "DKI Jakarta": {
    kab: ["Kepulauan Seribu"],
    kota: [
      "Jakarta Barat",
      "Jakarta Pusat",
      "Jakarta Selatan",
      "Jakarta Timur",
      "Jakarta Utara",
    ],
  },
  "Jawa Barat": {
    kab: [
      "Bandung",
      "Bandung Barat",
      "Bekasi",
      "Bogor",
      "Ciamis",
      "Cianjur",
      "Cirebon",
      "Garut",
      "Indramayu",
      "Karawang",
      "Kuningan",
      "Majalengka",
      "Pangandaran",
      "Purwakarta",
      "Subang",
      "Sukabumi",
      "Sumedang",
      "Tasikmalaya",
    ],
    kota: [
      "Bandung",
      "Banjar",
      "Bekasi",
      "Bogor",
      "Cimahi",
      "Cirebon",
      "Depok",
      "Sukabumi",
      "Tasikmalaya",
    ],
  },
  Banten: {
    kab: ["Lebak", "Pandeglang", "Serang", "Tangerang"],
    kota: ["Cilegon", "Serang", "Tangerang", "Tangerang Selatan"],
  },
  "Jawa Tengah": {
    kab: [
      "Banjarnegara",
      "Banyumas",
      "Batang",
      "Blora",
      "Boyolali",
      "Brebes",
      "Cilacap",
      "Demak",
      "Grobogan",
      "Jepara",
      "Karanganyar",
      "Kebumen",
      "Kendal",
      "Klaten",
      "Kudus",
      "Magelang",
      "Pati",
      "Pekalongan",
      "Pemalang",
      "Purbalingga",
      "Purworejo",
      "Rembang",
      "Semarang",
      "Sragen",
      "Sukoharjo",
      "Tegal",
      "Temanggung",
      "Wonogiri",
      "Wonosobo",
    ],
    kota: [
      "Magelang",
      "Pekalongan",
      "Salatiga",
      "Semarang",
      "Surakarta",
      "Tegal",
    ],
  },
  "DI Yogyakarta": {
    kab: ["Bantul", "Gunung Kidul", "Kulon Progo", "Sleman"],
    kota: ["Yogyakarta"],
  },
  "Jawa Timur": {
    kab: [
      "Bangkalan",
      "Banyuwangi",
      "Blitar",
      "Bojonegoro",
      "Bondowoso",
      "Gresik",
      "Jember",
      "Jombang",
      "Kediri",
      "Lamongan",
      "Lumajang",
      "Madiun",
      "Magetan",
      "Malang",
      "Mojokerto",
      "Nganjuk",
      "Ngawi",
      "Pacitan",
      "Pamekasan",
      "Pasuruan",
      "Ponorogo",
      "Probolinggo",
      "Sampang",
      "Sidoarjo",
      "Situbondo",
      "Sumenep",
      "Trenggalek",
      "Tuban",
      "Tulungagung",
    ],
    kota: [
      "Batu",
      "Blitar",
      "Kediri",
      "Madiun",
      "Malang",
      "Mojokerto",
      "Pasuruan",
      "Probolinggo",
      "Surabaya",
    ],
  },
  Bali: {
    kab: [
      "Badung",
      "Bangli",
      "Buleleng",
      "Gianyar",
      "Jembrana",
      "Karangasem",
      "Klungkung",
      "Tabanan",
    ],
    kota: ["Denpasar"],
  },
  "Nusa Tenggara Barat": {
    kab: [
      "Bima",
      "Dompu",
      "Lombok Barat",
      "Lombok Tengah",
      "Lombok Timur",
      "Lombok Utara",
      "Sumbawa",
      "Sumbawa Barat",
    ],
    kota: ["Bima", "Mataram"],
  },
  "Nusa Tenggara Timur": {
    kab: [
      "Alor",
      "Belu",
      "Ende",
      "Flores Timur",
      "Kupang",
      "Lembata",
      "Malaka",
      "Manggarai",
      "Manggarai Barat",
      "Manggarai Timur",
      "Nagekeo",
      "Ngada",
      "Rote Ndao",
      "Sabu Raijua",
      "Sikka",
      "Sumba Barat",
      "Sumba Barat Daya",
      "Sumba Tengah",
      "Sumba Timur",
      "Timor Tengah Selatan",
      "Timor Tengah Utara",
    ],
    kota: ["Kupang"],
  },
  "Kalimantan Barat": {
    kab: [
      "Bengkayang",
      "Kapuas Hulu",
      "Kayong Utara",
      "Ketapang",
      "Kubu Raya",
      "Landak",
      "Melawi",
      "Mempawah",
      "Sambas",
      "Sanggau",
      "Sekadau",
      "Sintang",
    ],
    kota: ["Pontianak", "Singkawang"],
  },
  "Kalimantan Tengah": {
    kab: [
      "Barito Selatan",
      "Barito Timur",
      "Barito Utara",
      "Gunung Mas",
      "Kapuas",
      "Katingan",
      "Kotawaringin Barat",
      "Kotawaringin Timur",
      "Lamandau",
      "Murung Raya",
      "Pulang Pisau",
      "Seruyan",
      "Sukamara",
    ],
    kota: ["Palangka Raya"],
  },
  "Kalimantan Selatan": {
    kab: [
      "Balangan",
      "Banjar",
      "Barito Kuala",
      "Hulu Sungai Selatan",
      "Hulu Sungai Tengah",
      "Hulu Sungai Utara",
      "Kotabaru",
      "Tabalong",
      "Tanah Bumbu",
      "Tanah Laut",
      "Tapin",
    ],
    kota: ["Banjarbaru", "Banjarmasin"],
  },
  "Kalimantan Timur": {
    kab: [
      "Berau",
      "Kutai Barat",
      "Kutai Kartanegara",
      "Kutai Timur",
      "Mahakam Ulu",
      "Paser",
      "Penajam Paser Utara",
    ],
    kota: ["Balikpapan", "Bontang", "Samarinda"],
  },
  "Kalimantan Utara": {
    kab: ["Bulungan", "Malinau", "Nunukan", "Tana Tidung"],
    kota: ["Tarakan"],
  },
  "Sulawesi Utara": {
    kab: [
      "Bolaang Mongondow",
      "Bolaang Mongondow Selatan",
      "Bolaang Mongondow Timur",
      "Bolaang Mongondow Utara",
      "Kepulauan Sangihe",
      "Kepulauan Siau Tagulandang Biaro",
      "Kepulauan Talaud",
      "Minahasa",
      "Minahasa Selatan",
      "Minahasa Tenggara",
      "Minahasa Utara",
    ],
    kota: ["Bitung", "Kotamobagu", "Manado", "Tomohon"],
  },
  Gorontalo: {
    kab: [
      "Boalemo",
      "Bone Bolango",
      "Gorontalo",
      "Gorontalo Utara",
      "Pohuwato",
    ],
    kota: ["Gorontalo"],
  },
  "Sulawesi Tengah": {
    kab: [
      "Banggai",
      "Banggai Kepulauan",
      "Banggai Laut",
      "Buol",
      "Donggala",
      "Morowali",
      "Morowali Utara",
      "Parigi Moutong",
      "Poso",
      "Sigi",
      "Tojo Una-Una",
      "Tolitoli",
    ],
    kota: ["Palu"],
  },
  "Sulawesi Barat": {
    kab: [
      "Majene",
      "Mamasa",
      "Mamuju",
      "Mamuju Tengah",
      "Pasangkayu",
      "Polewali Mandar",
    ],
    kota: [],
  },
  "Sulawesi Selatan": {
    kab: [
      "Bantaeng",
      "Barru",
      "Bone",
      "Bulukumba",
      "Enrekang",
      "Gowa",
      "Jeneponto",
      "Kepulauan Selayar",
      "Luwu",
      "Luwu Timur",
      "Luwu Utara",
      "Maros",
      "Pangkajene dan Kepulauan",
      "Pinrang",
      "Sidenreng Rappang",
      "Sinjai",
      "Soppeng",
      "Takalar",
      "Tana Toraja",
      "Toraja Utara",
      "Wajo",
    ],
    kota: ["Makassar", "Palopo", "Parepare"],
  },
  "Sulawesi Tenggara": {
    kab: [
      "Bombana",
      "Buton",
      "Buton Selatan",
      "Buton Tengah",
      "Buton Utara",
      "Kolaka",
      "Kolaka Timur",
      "Kolaka Utara",
      "Konawe",
      "Konawe Kepulauan",
      "Konawe Selatan",
      "Konawe Utara",
      "Muna",
      "Muna Barat",
      "Wakatobi",
    ],
    kota: ["Baubau", "Kendari"],
  },
  Maluku: {
    kab: [
      "Buru",
      "Buru Selatan",
      "Kepulauan Aru",
      "Kepulauan Tanimbar",
      "Maluku Barat Daya",
      "Maluku Tengah",
      "Maluku Tenggara",
      "Seram Bagian Barat",
      "Seram Bagian Timur",
    ],
    kota: ["Ambon", "Tual"],
  },
  "Maluku Utara": {
    kab: [
      "Halmahera Barat",
      "Halmahera Selatan",
      "Halmahera Tengah",
      "Halmahera Timur",
      "Halmahera Utara",
      "Kepulauan Sula",
      "Pulau Morotai",
      "Pulau Taliabu",
    ],
    kota: ["Ternate", "Tidore Kepulauan"],
  },
  Papua: {
    kab: [
      "Biak Numfor",
      "Jayapura",
      "Keerom",
      "Kepulauan Yapen",
      "Mamberamo Raya",
      "Sarmi",
      "Supiori",
      "Waropen",
    ],
    kota: ["Jayapura"],
  },
  "Papua Barat": {
    kab: [
      "Fakfak",
      "Kaimana",
      "Manokwari",
      "Manokwari Selatan",
      "Pegunungan Arfak",
      "Teluk Bintuni",
      "Teluk Wondama",
    ],
    kota: [],
  },
  "Papua Barat Daya": {
    kab: ["Maybrat", "Raja Ampat", "Sorong", "Sorong Selatan", "Tambrauw"],
    kota: ["Sorong"],
  },
  "Papua Selatan": {
    kab: ["Asmat", "Boven Digoel", "Mappi", "Merauke"],
    kota: [],
  },
  "Papua Tengah": {
    kab: [
      "Deiyai",
      "Dogiyai",
      "Intan Jaya",
      "Mimika",
      "Nabire",
      "Paniai",
      "Puncak",
      "Puncak Jaya",
    ],
    kota: [],
  },
  "Papua Pegunungan": {
    kab: [
      "Jayawijaya",
      "Lanny Jaya",
      "Mamberamo Tengah",
      "Nduga",
      "Pegunungan Bintang",
      "Tolikara",
      "Yahukimo",
      "Yalimo",
    ],
    kota: [],
  },
};

/**
 * Nama lain / nama lama kab/kota -> nama resmi. `bare`: boleh dikenali
 * walau tidak diawali "Kab."/"Kota" di alamat.
 */
export const WILAYAH_ALIAS: Array<{
  type: "kab" | "kota";
  alias: string;
  name: string;
  bare: boolean;
}> = [
  { type: "kab", alias: "Bolmong", name: "Bolaang Mongondow", bare: true },
  { type: "kab", alias: "Bulongan", name: "Bulungan", bare: false },
  { type: "kab", alias: "Deliyai", name: "Deiyai", bare: false },
  {
    type: "kab",
    alias: "Sitaro",
    name: "Kepulauan Siau Tagulandang Biaro",
    bare: true,
  },
  {
    type: "kab",
    alias: "Siau Tagulandang Biaro",
    name: "Kepulauan Siau Tagulandang Biaro",
    bare: false,
  },
  { type: "kab", alias: "Yapen Waropen", name: "Kepulauan Yapen", bare: false },
  {
    type: "kab",
    alias: "Lima Puluh Koto",
    name: "Lima Puluh Kota",
    bare: false,
  },
  { type: "kab", alias: "Selayar", name: "Kepulauan Selayar", bare: true },
  {
    type: "kab",
    alias: "Sidenreng Rapang",
    name: "Sidenreng Rappang",
    bare: false,
  },
  { type: "kab", alias: "Sidrap", name: "Sidenreng Rappang", bare: true },
  {
    type: "kab",
    alias: "Sawahlunto Sijunjung",
    name: "Sijunjung",
    bare: false,
  },
  { type: "kota", alias: "Solo", name: "Surakarta", bare: true },
  { type: "kab", alias: "Toba Samosir", name: "Toba", bare: true },
  { type: "kab", alias: "Tobasa", name: "Toba", bare: true },
  { type: "kab", alias: "Pontianak", name: "Mempawah", bare: false },
  { type: "kab", alias: "Mamuju Utara", name: "Pasangkayu", bare: true },
  {
    type: "kab",
    alias: "Maluku Tenggara Barat",
    name: "Kepulauan Tanimbar",
    bare: true,
  },
  {
    type: "kab",
    alias: "Pangkajene Kepulauan",
    name: "Pangkajene dan Kepulauan",
    bare: true,
  },
  {
    type: "kab",
    alias: "Pangkep",
    name: "Pangkajene dan Kepulauan",
    bare: true,
  },
];
